import { useCallback, useEffect, useMemo, useState } from 'react';

import { breakpoints } from '@shared/configs/theme/breakpoints';

const useResponsive = () => {
  const formatScreens = () => {
    const screenConfigs: Record<keyof typeof breakpoints, number> = { xl: 0, lg: 0, md: 0, sm: 0 };
    (Object.keys(breakpoints) as (keyof typeof breakpoints)[]).forEach((key) => {
      screenConfigs[key] = parseInt(breakpoints[key].replace('px', ''), 10);
    });

    return screenConfigs;
  };

  const screenConfigs = useMemo(() => formatScreens(), []);

  const checkResponsive = useCallback(
    (width: number): Record<keyof typeof breakpoints, boolean> => ({
      xl: width > screenConfigs.xl,
      lg: width > screenConfigs.lg,
      md: width > screenConfigs.md,
      sm: width > screenConfigs.sm,
    }),
    [screenConfigs]
  );

  const [responsive, setResponsive] = useState(checkResponsive(window.innerWidth));

  useEffect(() => {
    const handleResize = () => {
      setResponsive(checkResponsive(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [checkResponsive]);

  return responsive;
};

export default useResponsive;
